export const COOKIECONSENTLINKS = {
  COOKIESPOLICY: {
    SPWA: 'st/cookiespolicy',
    STATICWEB: 'legal/cookie-policy',
  },
  SECURITYPRIVACY: {
    SPWA: 'st/securityprivacy',
    STATICWEB: 'legal/security-privacy',
  },
  HOSTELTERMSANDCONDITIONS: {
    SPWA: 'st/hosteltermsandconditions',
    STATICWEB: 'legal/hostel-terms-and-conditions',
  },
  GUARANTEE: {
    SPWA: 'st/guarantee',
    STATICWEB: 'guarantee',
  },
  REVIEWGUIDELINES: {
    SPWA: 'st/reviewguidelines',
    STATICWEB: 'legal/review-guidelines',
  },
  COUPONS: {
    SPWA: '',
    STATICWEB: 'legal/coupons-terms-and-conditions',
  },
  VOUCHERS: {
    SPWA: '',
    STATICWEB: 'legal/voucher-terms-and-conditions',
  },
};
